import { Reveal, Chapter } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";

const SERVICES = [
  {
    n: "01",
    title: "Concept Alignment",
    copy: "Developing recruitment strategies aligned with your brand positioning, location, target market and operating model.",
  },
  {
    n: "02",
    title: "Talent Acquisition",
    copy: "Building leadership and operational teams capable of translating the concept into reality.",
  },
  {
    n: "03",
    title: "Operating Manuals",
    copy: "Creation and development of customized SOPs, service standards and training guidelines.",
  },
  {
    n: "04",
    title: "Brand Talent",
    copy: "Recruitment of Marketing, PR, Sales and Brand professionals who position hospitality concepts successfully within their market.",
  },
];

const PreOpening = () => (
  <section id="pre-opening" data-testid="preopening-section" className="relative bg-ink text-ivory overflow-hidden">
    <div className="absolute inset-0">
      <img
        src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=2200&auto=format&fit=crop"
        alt="Restaurant interior before service"
        className="w-full h-full object-cover opacity-20"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/80 to-ink" />
    </div>

    <div className="relative z-10 max-w-[1600px] mx-auto px-6 lg:px-12 py-28 lg:py-40">
      <Reveal>
        <Chapter number="04" label="Pre-Opening Talent Framework" dark />
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-light leading-[1.05] max-w-4xl">
          Building Exceptional Teams <span className="italic text-bronze">Before Opening Day</span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 text-ivory/60 font-light leading-relaxed max-w-2xl">
          A successful hospitality opening begins long before the first guest arrives. BR
          Hospitality supports owners, developers and operators in creating recruitment and
          operational frameworks designed specifically for new hospitality concepts.
        </p>
      </Reveal>

      <div className="mt-16 lg:mt-24 grid md:grid-cols-2 gap-px bg-ivory/10 border border-ivory/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={0.1 + i * 0.1} className="bg-ink/80 backdrop-blur-sm">
            <div data-testid={`preopening-service-${s.n}`} className="p-10 lg:p-14 group h-full">
              <span className="font-serif italic text-bronze/70 text-lg">{s.n}</span>
              <h3 className="font-serif text-2xl lg:text-3xl font-light mt-5 group-hover:text-bronze transition-colors duration-500">
                {s.title}
              </h3>
              <p className="mt-4 text-sm text-ivory/55 leading-relaxed">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <button
          data-testid="preopening-cta"
          onClick={() => scrollToId("#contact")}
          className="mt-14 text-[11px] tracking-[0.25em] uppercase px-8 py-4 bg-bronze text-ink hover:bg-ivory transition-colors duration-500"
        >
          Discuss Your Pre-Opening Project
        </button>
      </Reveal>
    </div>
  </section>
);

export default PreOpening;
